import React, { useEffect } from "react";
import styles from "./CustomToast.module.css";

const CustomToast = ({ message, type = "success", onClose}) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(); // Закрытие тоста через 3 секунды
        }, 10000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`${styles.toast} ${type === "error" ? styles.toastError : type === "warn" ? styles.toastWarning : ""}`}>
            {message}
            <button className={styles.toastClose} onClick={onClose}>✖</button>
        </div>
    );
};

export default CustomToast;